<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <service-header
        @export-pdf="exportPDF"
        @export-csv="exportCSV"
        @print-table="printTable"
        @refresh="refreshList"
      ></service-header>

      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input type="text" placeholder="Recherche" class="dark-input" />
                <a href="javascript:void(0);" class="btn btn-searchset"
                  ><i data-feather="search" class="feather-search"></i
                ></a>
              </div>
            </div>
            <div class="search-path">
              <a
                class="btn btn-filter"
                id="filter_search"
                v-on:click="filter = !filter"
                :class="{ setclose: filter }"
              >
                <vue-feather type="filter" class="filter-icon"></vue-feather>
                <span
                  ><img src="@/assets/img/icons/closes.svg" alt="img"
                /></span>
              </a>
            </div>
            <div class="form-sort">
              <vue-feather type="sliders" class="info-img"></vue-feather>
              <vue-select
                :options="Sortby"
                id="sortby"
                placeholder="Par Date"
              />
            </div>
          </div>
          <!-- /Filter -->
          <div
            class="card mb-0"
            :style="{ display: filter ? 'block' : 'none' }"
            id="filter_inputs"
          >
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-lg-12 col-sm-12">
                  <div class="row">
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label class="form-label">Service</label>
                        <div class="input-with-icon">
                          <vue-feather type="box" class="info-img"></vue-feather>
                          <vue-select
                            :options="ChooseFilter"
                            id="choosefilter"
                            placeholder="Choisir un service"
                            v-model="activeFilters.name"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label class="form-label">Catégorie</label>
                        <div class="input-with-icon">
                          <vue-feather type="stop-circle" class="info-img"></vue-feather>
                          <vue-select
                            :options="CategroyFilter"
                            id="categroyfilter"
                            placeholder="Choisir une Catégorie"
                            v-model="activeFilters.category"
                          />
                        </div>
                      </div>
                    </div>

                    
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks my-4">
                        <a class="btn btn-filters ms-auto">
                          <i data-feather="search" class="feather-search"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <div class="table-responsive product-list">
            <a-table
              class="table datanew table-hover table-center mb-0"
              :columns="columns"
              :data-source="filteredData.length ? filteredData : data"
              :row-selection="{}"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'statut_achat'">
                  <div>
                    <span
                      :class="
                        record.statut_achat
                          ? 'badge badge-linesuccess'
                          : 'badge badge-linedanger'
                      "
                      >{{ record.statut_achat ? "Actif" : "Inactif" }}</span
                    >
                  </div>
                </template>
                <template v-if="column.key === 'statut_vente'">
                  <div>
                    <span
                      :class="
                        record.statut_vente
                          ? 'badge badge-linesuccess'
                          : 'badge badge-linedanger'
                      "
                      >{{ record.statut_vente ? "Actif" : "Inactif" }}</span
                    >
                  </div>
                </template>
                <template v-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <router-link
                        class="me-2 p-2"
                        to="/produits/modification-service"
                        @click="selectService(record)"
                      >
                        <i data-feather="edit" class="feather-edit"></i>
                      </router-link>
                      <a
                        class="confirm-text p-2"
                        @click="showConfirmation(record.id)"
                        href="javascript:void(0);"
                      >
                        <vue-feather
                          type="trash-2"
                          class="trash-2"
                        ></vue-feather>
                      </a>
                    </div>
                  </td>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>
  <product-list-modal></product-list-modal>
</template>
<script>
import { getServicesData, deleteService, getCategoriesData } from "@/services/productsService";
import serviceHeader from "./service-header.vue";
import { toast } from "vue3-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getCompanyLogoDataUrl } from "@/services/companyService";

const columns = [
  {
    title: "Réf",
    dataIndex: "reference_service",
    sorter: {
      compare: (a, b) => String(a.reference_service || "").localeCompare(String(b.reference_service || "")),
    },
  },
  {
    title: "Service",
    dataIndex: "nom",
    sorter: {
      compare: (a, b) => String(a.nom || "").localeCompare(String(b.nom || "")),
    },
  },

  {
    title: "Description",
    dataIndex: "description",
    sorter: {
      compare: (a, b) => String(a.description || "").localeCompare(String(b.description || "")),
    },
  },
  {
    title: "Catégorie",
    dataIndex: "categorie_nom",
    sorter: {
      compare: (a, b) => String(a.categorie_nom || "").localeCompare(String(b.categorie_nom || "")),
    },
  },
  {
    title: "Durér de jours",
    dataIndex: "duree_jours",
    sorter: {
      compare: (a, b) => (Number(a.duree_jours) || 0) - (Number(b.duree_jours) || 0),
    },
  },
  {
    title: "Prix de Vente",
    dataIndex: "prix_vente",
    sorter: {
      compare: (a, b) => (Number(a.prix_vente) || 0) - (Number(b.prix_vente) || 0),
    },
  },
  {
    title: "Status d'Achat",
    dataIndex: "statut_achat",
    key: "statut_achat",
    sorter: {
      compare: (a, b) => (a.statut_achat === b.statut_achat ? 0 : a.statut_achat ? -1 : 1),
    },
  },
  {
    title: "Status de Vente",
    dataIndex: "statut_vente",
    key: "statut_vente",
    sorter: {
      compare: (a, b) => (a.statut_vente === b.statut_vente ? 0 : a.statut_vente ? -1 : 1),
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
const data = [];
import Swal from "sweetalert2";
export default {
  components: {
    serviceHeader,
  },
  data() {
    return {
      filter: false,
      Sortby: ["Par Date", "14 09 23", "11 09 23"],
      ChooseFilter: ["Choisir un service"],
      CategroyFilter: ["Toutes les catégories"],
      data,
      columns,
      selectedProduct: {},
      filteredData: [],
      activeFilters: {
        name: null,
        category: null,
      },
    };
  },
  methods: {
    async loadCompanyLogoDataUrl() {
      try {
        return await getCompanyLogoDataUrl('logo');
      } catch (e) {
        return null;
      }
    },
    refreshList() {
      this.getServicesData();
    },
    exportCSV() {
      const rows = this.data;
      const headers = [
        "Réf",
        "Service",
        "Description",
        "Catégorie",
        "Durée (jours)",
        "Prix de Vente",
        "Achat",
        "Vente",
      ];
      const csv = [
        headers.join(","),
        ...rows.map((r) =>
          [
            r.reference_service || `SRV-${r.id}`,
            r.nom || "",
            r.description || "",
            r.categorie_nom || "",
            r.duree_jours != null ? r.duree_jours : "",
            r.prix_vente != null ? r.prix_vente : "",
            r.statut_achat ? "Actif" : "Inactif",
            r.statut_vente ? "Actif" : "Inactif",
          ]
            .map((v) => `"${String(v).replace(/"/g, '""')}"`)
            .join(",")
        ),
      ].join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `services_${new Date().toISOString().slice(0,10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    async exportPDF() {
      try {
        const rows = this.data;
        if (!rows.length) return;

        const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
        const dataUrl = await this.loadCompanyLogoDataUrl();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const headerHeight = 26;
        const margin = 12;

        const drawHeader = () => {
          if (!dataUrl) return;
          const logoW = 42, logoH = 16;
          const x = (pageWidth - logoW) / 2;
          const y = 8;
          try {
            const fmt = dataUrl.startsWith('data:image/png') ? 'PNG' : 'JPEG';
            doc.addImage(dataUrl, fmt, x, y, logoW, logoH);
          } catch (_) { /* ignore image draw errors */ }
        };

        const body = rows.map((r) => [
          r.reference_service || `SRV-${r.id}`,
          r.nom || '-',
          r.description || '-',
          r.categorie_nom || '-',
          r.duree_jours != null ? String(r.duree_jours) : '-',
          r.prix_vente != null ? Number(r.prix_vente).toFixed(2) + ' MAD' : '-',
          r.statut_achat ? '✓ Actif' : '✗ Inactif',
          r.statut_vente ? '✓ Actif' : '✗ Inactif',
        ]);

        autoTable(doc, {
          startY: headerHeight,
          head: [[
            'Référence', 'Service', 'Description', 'Catégorie', 'Durée (jours)', 'Prix de Vente', 'Achat', 'Vente'
          ]],
          body,
          headStyles: { fillColor: [30, 104, 163], textColor: 255, fontStyle: 'bold', fontSize: 9, halign: 'center' },
          styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak', cellWidth: 'wrap' },
          columnStyles: {
            0: { cellWidth: 25, fontStyle: 'bold' },
            1: { cellWidth: 35 },
            2: { cellWidth: 50 },
            3: { cellWidth: 35 },
            4: { cellWidth: 25, halign: 'center' },
            5: { cellWidth: 28, halign: 'right' },
            6: { cellWidth: 20, halign: 'center' },
            7: { cellWidth: 20, halign: 'center' },
          },
          alternateRowStyles: { fillColor: [245, 245, 245] },
          didDrawPage: () => {
            drawHeader();
            const pageCount = doc.internal.getNumberOfPages();
            const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
            doc.setFontSize(9);
            doc.setTextColor(120);
            doc.text(`Page ${currentPage} sur ${pageCount}`, pageWidth - margin, pageHeight - 8, { align: 'right' });
            doc.setTextColor(0);
          },
          margin: { left: margin, right: margin, top: headerHeight + 4, bottom: 15 },
        });

        doc.save(`services_${new Date().toISOString().slice(0,10)}.pdf`);
      } catch (err) {
        console.error('Error exporting services PDF', err);
      }
    },
    printTable() {
      const rows = this.data;
      const win = window.open('', '_blank');
      const html = `
        <html><head><title>Liste des Services</title>
        <style>table{width:100%;border-collapse:collapse}th,td{border:1px solid #ccc;padding:6px;text-align:left}</style>
        </head><body>
        <h3>Liste des Services</h3>
        <table>
          <thead>
            <tr>
              <th>Réf</th><th>Service</th><th>Description</th><th>Catégorie</th><th>Durée (jours)</th><th>Prix de Vente</th><th>Achat</th><th>Vente</th>
            </tr>
          </thead>
          <tbody>
            ${rows.map((r) => `
              <tr>
                <td>${r.reference_service || `SRV-${r.id}`}</td>
                <td>${r.nom || ''}</td>
                <td>${r.description || ''}</td>
                <td>${r.categorie_nom || ''}</td>
                <td>${r.duree_jours != null ? r.duree_jours : ''}</td>
                <td>${r.prix_vente != null ? r.prix_vente : ''}</td>
                <td>${r.statut_achat ? 'Actif' : 'Inactif'}</td>
                <td>${r.statut_vente ? 'Actif' : 'Inactif'}</td>
              </tr>`).join('')}
          </tbody>
        </table>
        </body></html>`;
      win.document.open();
      win.document.write(html);
      win.document.close();
      setTimeout(() => { try { win.focus(); win.print(); } catch(e){ /* ignore */ } }, 100);
    },
    showConfirmation(id) {
      Swal.fire({
        title: "Es-tu sûr de vouloir supprimer ce service ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprime-le !",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        cancelButtonText: "Annuler",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteService(id);
            if (localStorage.getItem("services") != null) {
              let services = JSON.parse(localStorage.getItem("services"));
              services = services.filter((item) => item.id !== id);
              const jsonData = JSON.stringify(services);
              localStorage.setItem("services", jsonData);
            }

            this.data = this.data.filter((item) => item.id !== id);
            Swal.fire({
              icon: "success",
              title: "Supprimer!",
              text: "Le Service a été supprimer",
              confirmButtonClass: "btn btn-success",
            });
          } catch (error) {
            console.error(error);
            toast.error(error.response.data.message);
            toast.error(error.response.data.error);
          }
        }
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    async getServicesData() {
      this.data = [];
      if (localStorage.getItem("services") != null) {
        const data = JSON.parse(localStorage.getItem("services"));
        data.map((m) => {
          this.data.push({
            id: m.id,
            societe_id: m.societe_id,
            nom: m.nom,
            description: m.description,
            duree_jours: m.duree_jours,
            prix_vente_minimum: m.prix_vente_minimum,
            prix_achat: m.prix_achat,
            prix_vente: m.prix_vente,
            reference_service: m.reference_service,
            statut_achat: m.statut_achat,
            statut_vente: m.statut_vente,
            taux_taxe: m.taux_taxe,
            categorie_id: m.categorie.id,
            categorie_nom: m.categorie.name,
            CreatedOn: this.formatDate(m.created_at),
          });
        });
      } else {
        try {
          const data = await getServicesData();
          data.map((m) => {
            this.data.push({
              id: m.id,
              societe_id: m.societe_id,
              nom: m.nom,
              description: m.description,
              duree_jours: m.duree_jours,
              prix_vente_minimum: m.prix_vente_minimum,
              prix_achat: m.prix_achat,
              prix_vente: m.prix_vente,
              reference_service: m.reference_service,
              statut_achat: m.statut_achat,
              statut_vente: m.statut_vente,
              taux_taxe: m.taux_taxe,
              categorie_id: m.categorie.id,
              categorie_nom: m.categorie.name,
              CreatedOn: this.formatDate(m.created_at),
            });
          });
        } catch (error) {
          console.error(error);
          toast.error(error.response.data.message);
        }
      }
      // Initialize filters and filteredData
      this.filteredData = [...this.data];
      this.updateFilterOptions();
    },
    async loadCategories() {
      try {
        const cats = await getCategoriesData();
        const names = Array.from(new Set((cats || []).map((c) => c.name).filter(Boolean))).sort((a, b) => a.localeCompare(b, 'fr'));
        this.CategroyFilter = ["Toutes les catégories", ...names];
      } catch (e) {
        // keep default
      }
    },
    updateFilterOptions() {
      const names = Array.from(new Set(this.data.map((s) => s.nom).filter(Boolean))).sort((a, b) => a.localeCompare(b, 'fr'));
      this.ChooseFilter = ["Tous les services", ...names];
    },
    applyFilters() {
      const name = this.activeFilters.name && this.activeFilters.name !== 'Tous les services' ? this.activeFilters.name : null;
      const category = this.activeFilters.category && this.activeFilters.category !== 'Toutes les catégories' ? this.activeFilters.category : null;
      this.filteredData = this.data.filter((s) => {
        const okName = name ? s.nom === name : true;
        const okCat = category ? s.categorie_nom === category : true;
        return okName && okCat;
      });
    },

    selectService(item) {
      this.selectedService = item;
      localStorage.setItem("service", JSON.stringify(this.selectedService));
    },
  },
  mounted() {
    this.getServicesData();
    this.loadCategories();
  },
  watch: {
    'activeFilters.name'() {
      this.applyFilters();
    },
    'activeFilters.category'() {
      this.applyFilters();
    },
  },
};
</script>
